import { render, staticRenderFns } from "./gameBlock.vue?vue&type=template&id=7904c220&scoped=true"
import script from "./gameBlock.vue?vue&type=script&lang=js"
export * from "./gameBlock.vue?vue&type=script&lang=js"
import style0 from "./gameBlock.vue?vue&type=style&index=0&id=7904c220&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7904c220",
  null
  
)

export default component.exports